import { useRef } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import { X, Check, RotateCcw } from 'lucide-react';

export function SignaturePad({ onSave, onCancel, title = 'Firma' }) {
  const sigRef = useRef(null);

  const handleClear = () => {
    sigRef.current?.clear();
  };

  const handleSave = () => {
    if (sigRef.current?.isEmpty()) {
      alert('Por favor, firma antes de guardar');
      return;
    }
    const dataUrl = sigRef.current?.toDataURL('image/png');
    onSave?.(dataUrl);
  };

  return (
    <div className="modal-overlay" onClick={onCancel} data-testid="signature-overlay">
      <div className="modal-content" onClick={(e) => e.stopPropagation()} data-testid="signature-modal">
        {/* Header */}
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-2xl font-bold text-zinc-900">{title}</h2>
          <button 
            onClick={onCancel}
            className="h-14 w-14 flex items-center justify-center rounded-full bg-zinc-100 active:bg-zinc-200"
            data-testid="signature-cancel"
          >
            <X className="w-7 h-7 text-zinc-600" />
          </button>
        </div>

        {/* Canvas */}
        <div className="mb-6">
          <SignatureCanvas
            ref={sigRef}
            canvasProps={{
              className: 'signature-canvas w-full',
              style: { width: '100%', height: '200px' },
            }}
            data-testid="signature-canvas"
          />
        </div>

        {/* Actions */}
        <div className="grid grid-cols-3 gap-3">
          <button
            onClick={onCancel}
            className="h-16 flex items-center justify-center gap-2 bg-white border-2 border-zinc-300 rounded-xl text-lg font-bold btn-press"
            data-testid="signature-btn-cancel"
          >
            <X className="w-5 h-5" />
            Cancelar
          </button>
          <button
            onClick={handleClear}
            className="h-16 flex items-center justify-center gap-2 bg-zinc-100 rounded-xl text-lg font-bold btn-press"
            data-testid="signature-btn-clear"
          >
            <RotateCcw className="w-5 h-5" />
            Limpiar
          </button>
          <button
            onClick={handleSave}
            className="h-16 flex items-center justify-center gap-2 bg-blue-600 text-white rounded-xl text-lg font-bold btn-press"
            data-testid="signature-btn-save"
          >
            <Check className="w-5 h-5" />
            Guardar
          </button>
        </div>
      </div>
    </div>
  );
}
